module.exports = __webpack_public_path__ + "static/media/6COPUOS1.d37229ac.jpg";